import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { RequestForm } from '../components/RequestForm'
import { AnimatedGradientBackground } from '@/components/common/AnimatedGradientBackground'

export function RequestPage() {
  const [submitted, setSubmitted] = useState(false)
  const [searchParams] = useSearchParams()
  const initialService = searchParams.get('service') ?? undefined
  const initialOffering = searchParams.get('offering') ?? undefined
  const initialServiceKey = searchParams.get('sk') ?? undefined

  if (submitted) {
    return (
      <div className="container mx-auto max-w-3xl px-4 py-24 text-center space-y-4">
        <AnimatedGradientBackground />
        <div className="relative rounded-2xl bg-brand-white px-8 py-10 shadow-sm dark:bg-brand-black">
          <h1 className="text-3xl font-bold">Request Submitted!</h1>
          <p className="text-muted-foreground max-w-md mx-auto">
            Thanks — your request was sent! We'll review it and follow up by email shortly.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="container mx-auto max-w-3xl px-4 py-12 lg:max-w-5xl">
      <AnimatedGradientBackground />
      <div className="relative rounded-2xl bg-brand-white px-8 py-10 shadow-sm dark:bg-brand-black">
        <div className="mb-10 space-y-2">
          <h1 className="text-3xl font-bold">Service Request</h1>
          <p className="text-muted-foreground">
            Tell us about the services you need and we'll put together a quote for you.
          </p>
        </div>
        <RequestForm onSuccess={() => setSubmitted(true)} initialService={initialService} initialOffering={initialOffering} initialServiceKey={initialServiceKey} />
      </div>
    </div>
  )
}
